import { render, staticRenderFns } from "./regresos.vue?vue&type=template&id=5e7c531e&scoped=true&"
import script from "./regresos.vue?vue&type=script&lang=js&"
export * from "./regresos.vue?vue&type=script&lang=js&"
import style0 from "./regresos.vue?vue&type=style&index=0&id=5e7c531e&scoped=true&lang=css&"
import style1 from "./regresos.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7c531e",
  null
  
)

export default component.exports